/* FlexyMinds homepage: quotes slider, reviews carousel, expert cards row, collection filters and footer "back to top". */
(function () {
  if (window.fmHomeLoaded) return;
  window.fmHomeLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FADE_MS = 300;

  function mod(n, m) {
    return ((n % m) + m) % m;
  }

  function preload(src) {
    if (!src) return;
    var img = new Image();
    img.src = src;
  }

  function Carousel(root) {
    var json = root.querySelector('[data-fm-slides]');
    if (!json) return;
    try {
      this.slides = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }
    if (!this.slides || this.slides.length < 2) return;

    this.root = root;
    this.index = 0;
    this.busy = false;
    this.dots = root.querySelectorAll('[data-fm-dot]');
    this.imgs = {};
    var self = this;

    root.querySelectorAll('[data-fm-img]').forEach(function (img) {
      self.imgs[img.getAttribute('data-fm-img')] = img;
    });
    this.fields = {
      quote: root.querySelector('[data-fm-field="quote"]'),
      author: root.querySelector('[data-fm-field="author"]')
    };

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.go(parseInt(dot.getAttribute('data-fm-dot'), 10));
      });
    });

    root.querySelectorAll('[data-fm-go]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.go(self.index + (btn.getAttribute('data-fm-go') === 'prev' ? -1 : 1));
      });
    });

    // Small review images advance the slider as well
    ['next', 'next2'].forEach(function (key) {
      var img = self.imgs[key];
      if (img && root.getAttribute('data-fm-carousel') === 'reviews') {
        img.parentNode.style.cursor = 'pointer';
        img.parentNode.addEventListener('click', function () {
          self.go(self.index + (key === 'next' ? 1 : 2));
        });
      }
    });

    this.bindSwipe();
    this.bindAutoplay(parseInt(root.getAttribute('data-autoplay'), 10) || 0);
    this.preloadAround(0);
  }

  Carousel.prototype.slide = function (offset) {
    return this.slides[mod(this.index + offset, this.slides.length)];
  };

  Carousel.prototype.preloadAround = function (index) {
    var n = this.slides.length;
    preload(this.slides[mod(index + 1, n)].main);
    preload(this.slides[mod(index - 1, n)].main);
  };

  Carousel.prototype.render = function () {
    var imgs = this.imgs;
    var cur = this.slide(0);
    if (imgs.main) {
      imgs.main.src = cur.main;
      imgs.main.alt = cur.alt || '';
    }
    if (imgs.prev) imgs.prev.src = this.slide(-1).side;
    if (imgs.next) imgs.next.src = this.slide(1).side;
    if (imgs.next2) imgs.next2.src = this.slide(2).side;
    if (this.fields.quote) this.fields.quote.textContent = cur.quote;
    if (this.fields.author) this.fields.author.textContent = cur.author;

    var index = this.index;
    this.dots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  };

  Carousel.prototype.go = function (target) {
    var next = mod(target, this.slides.length);
    if (next === this.index || this.busy) return;
    var self = this;
    this.index = next;

    if (reduceMotion) {
      this.render();
      return;
    }

    this.busy = true;
    this.root.classList.add('is-fading');
    setTimeout(function () {
      self.render();
      var main = self.imgs.main;
      var done = function () {
        self.root.classList.remove('is-fading');
        self.busy = false;
      };
      if (main && !main.complete) {
        main.addEventListener('load', done, { once: true });
        main.addEventListener('error', done, { once: true });
        setTimeout(done, 1200);
      } else {
        done();
      }
      self.preloadAround(self.index);
    }, FADE_MS);
  };

  Carousel.prototype.next = function () {
    this.go(this.index + 1);
  };

  Carousel.prototype.bindSwipe = function () {
    var self = this;
    var startX = 0;
    var startY = 0;
    this.root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    this.root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        self.go(self.index + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
  };

  Carousel.prototype.bindAutoplay = function (seconds) {
    if (!seconds || reduceMotion) return;
    var self = this;
    var timer = null;
    var visible = false;
    var hovered = false;

    function stop() {
      clearInterval(timer);
      timer = null;
    }
    function start() {
      stop();
      if (visible && !hovered) {
        timer = setInterval(function () {
          self.next();
        }, seconds * 1000);
      }
    }

    this.root.addEventListener('mouseenter', function () { hovered = true; stop(); });
    this.root.addEventListener('mouseleave', function () { hovered = false; start(); });
    this.root.addEventListener('focusin', function () { hovered = true; stop(); });
    this.root.addEventListener('focusout', function () { hovered = false; start(); });
    this.root.addEventListener('touchstart', function () { stop(); start(); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        start();
      }, { threshold: 0.3 }).observe(this.root);
    } else {
      visible = true;
      start();
    }
  };

  /* Quotes: a track that slides. Slides are rotated between the track ends so it loops;
     the active slide always ends up at DOM index CENTER (sizes and position come from CSS). */
  var CENTER = 2;

  function Slider(root) {
    this.root = root;
    this.track = root.querySelector('[data-fm-track]');
    this.count = parseInt(root.getAttribute('data-count'), 10) || 0;
    if (!this.track || this.count < 2) return;

    this.index = 0;
    this.busy = false;
    this.speed = reduceMotion ? 0 : 650;
    this.dots = root.querySelectorAll('[data-fm-dot]');
    this.text = root.querySelector('.fm-quotes__text');
    this.fields = {
      quote: root.querySelector('[data-fm-field="quote"]'),
      author: root.querySelector('[data-fm-field="author"]')
    };
    var self = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var n = self.count;
        var d = mod(parseInt(dot.getAttribute('data-fm-dot'), 10) - self.index, n);
        self.step(d > n / 2 ? d - n : d);
      });
    });

    this.bindDrag();
    this.bindAutoplay(parseInt(root.getAttribute('data-autoplay'), 10) || 0);
    this.loadImagesNearby();
  }

  Slider.prototype.bindAutoplay = Carousel.prototype.bindAutoplay;

  Slider.prototype.next = function () {
    this.step(1);
  };

  Slider.prototype.items = function () {
    return this.track.children;
  };

  Slider.prototype.setPos = function (pos) {
    this.track.style.setProperty('--pos', pos);
  };

  Slider.prototype.setDrag = function (px) {
    this.track.style.setProperty('--drag', px + 'px');
  };

  // Moves without animation (used when slides change ends)
  Slider.prototype.instant = function (fn) {
    this.root.classList.add('is-instant');
    fn();
    void this.track.offsetWidth;
    this.root.classList.remove('is-instant');
  };

  Slider.prototype.step = function (d) {
    if (!d || this.busy) return;
    var self = this;
    var track = this.track;
    var target = CENTER + d;
    this.busy = true;
    this.root.classList.add('is-moving');

    if (d < 0) {
      // bring slides from the far end to the front first; the view does not change
      this.instant(function () {
        for (var i = 0; i < -d; i++) track.insertBefore(track.lastElementChild, track.firstElementChild);
        self.setPos(CENTER - d);
      });
      target = CENTER;
    }

    var items = this.items();
    Array.prototype.forEach.call(items, function (el, i) {
      el.classList.toggle('is-active', i === target);
    });
    this.setPos(target);
    this.setDrag(0);
    this.select(parseInt(items[target].getAttribute('data-index'), 10));

    setTimeout(function () {
      if (d > 0) {
        self.instant(function () {
          for (var i = 0; i < d; i++) track.appendChild(track.firstElementChild);
          self.setPos(CENTER);
        });
      }
      self.root.classList.remove('is-moving');
      self.busy = false;
    }, this.speed + 30);
  };

  Slider.prototype.select = function (index) {
    var self = this;
    this.index = index;

    this.dots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    var active = this.track.querySelector('.is-active');
    var quote = active.getAttribute('data-quote');
    var author = active.getAttribute('data-author');
    if (!this.text) return;
    this.text.classList.add('is-switching');
    clearTimeout(this.textTimer);
    this.textTimer = setTimeout(function () {
      if (self.fields.quote) self.fields.quote.textContent = quote;
      if (self.fields.author) self.fields.author.textContent = author;
      self.text.classList.remove('is-switching');
    }, reduceMotion ? 0 : 250);
  };

  // Swipe / mouse drag: the track follows the pointer, then snaps to the next slide
  Slider.prototype.bindDrag = function () {
    var self = this;
    var track = this.track;
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var down = false;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      if (self.busy || e.button > 0) return;
      down = true;
      moved = false;
      dx = 0;
      startX = e.clientX;
      startY = e.clientY;
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(e.clientY - startY) > Math.abs(dx)) {
          down = false; // vertical scroll
          return;
        }
        moved = true;
        self.root.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      self.setDrag(dx);
    });

    function release() {
      if (!down) return;
      down = false;
      self.root.classList.remove('is-dragging');
      if (!moved) return;
      var limit = Math.min(60, track.parentNode.clientWidth * 0.08);
      if (dx < -limit) self.step(1);
      else if (dx > limit) self.step(-1);
      else self.setDrag(0);
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);

    // a tap on a side slide brings it to the middle
    track.addEventListener('click', function (e) {
      if (moved) {
        moved = false;
        return;
      }
      var slide = e.target.closest('.fm-quotes__slide');
      if (!slide) return;
      var i = Array.prototype.indexOf.call(self.items(), slide);
      if (i !== CENTER && i !== -1) self.step(i - CENTER);
    });
  };

  // Slides off to the side are lazy images the browser may never load; load them before they are needed
  Slider.prototype.loadImagesNearby = function () {
    var imgs = this.track.querySelectorAll('img[loading="lazy"]');
    function load() {
      imgs.forEach(function (img) { img.loading = 'eager'; });
    }
    if (!('IntersectionObserver' in window)) return load();
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      load();
    }, { rootMargin: '600px 0px' });
    io.observe(this.root);
  };

  // Collection filters: mobile "Shop by" panel + submit on change
  function initFilters(root) {
    if (root.fmFilters) return;
    root.fmFilters = true;

    var toggle = root.querySelector('[data-fm-shopby]');
    var panel = root.querySelector('[data-fm-filters]');
    var close = root.querySelector('[data-fm-shopby-close]');
    var form = root.querySelector('[data-fm-filter-form]');

    function setOpen(open) {
      if (!toggle || !panel) return;
      panel.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) toggle.focus({ preventScroll: true });
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(!panel.classList.contains('is-open'));
      });
    }
    if (close) close.addEventListener('click', function () { setOpen(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (panel && panel.classList.contains('is-open') && !panel.contains(e.target) && !toggle.contains(e.target)) {
        setOpen(false);
      }
    });

    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return;
        submitFilters(form);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitFilters(form);
      });
    }
  }

  function submitFilters(form) {
    var params = new URLSearchParams(new FormData(form));
    var clean = new URLSearchParams();
    params.forEach(function (value, key) {
      if (value !== '') clean.append(key, value);
    });
    var query = clean.toString();
    window.location.href = form.getAttribute('action') + (query ? '?' + query : '') + '#FmCollectionGrid';
  }

  // Scroll-snap row with prev/next arrows and dots (fm-research). Controls hide when every item fits.
  // Mouse drag for scroll-snap rows (touch swipes natively): the row follows the cursor with snapping off,
  // then goes to the next / previous card in the drag direction
  function bindMouseDrag(track, step, maxIndex, go) {
    var startX = 0;
    var startLeft = 0;
    var dx = 0;
    var down = false;
    var moved = false;
    var snapTimer;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      moved = false;
      dx = 0;
      startX = e.clientX;
      startLeft = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < 6) return;
        moved = true;
        clearTimeout(snapTimer);
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      track.scrollLeft = startLeft - dx;
    });

    function release() {
      if (!down) return;
      down = false;
      if (!moved) return;
      var size = step();
      var pos = track.scrollLeft / size;
      var limit = Math.min(60, size * 0.15);
      var index = dx < -limit ? Math.ceil(pos) : dx > limit ? Math.floor(pos) : Math.round(pos);
      // keep snapping off until the smooth scroll lands, else the browser snaps mid-way
      track.classList.remove('is-dragging');
      track.classList.add('is-settling');
      go(Math.max(0, Math.min(maxIndex(), index)));
      snapTimer = setTimeout(function () { track.classList.remove('is-settling'); }, 600);
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    // no native image / link drag, no click after a drag
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('click', function (e) {
      if (!moved) return;
      moved = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function initHScroll(root) {
    var track = root.querySelector('[data-fm-track]');
    if (!track || track.fmHScroll) return;
    track.fmHScroll = true;

    var prev = root.querySelector('[data-fm-prev]');
    var next = root.querySelector('[data-fm-next]');
    var dots = root.querySelectorAll('[data-fm-dot]');
    var ticking = false;

    function step() {
      var items = track.children;
      if (items.length < 2) return track.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function maxIndex() {
      var room = track.scrollWidth - track.clientWidth;
      return room > 2 ? Math.ceil((room - 2) / step()) : 0;
    }

    function current() {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) return maxIndex();
      return Math.round(track.scrollLeft / step());
    }

    function update() {
      var last = maxIndex();
      var index = Math.min(current(), last);
      root.classList.toggle('is-static', last === 0);
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= last;
      dots.forEach(function (dot, i) {
        dot.hidden = i > last;
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      // elements outside the track that follow the current slide (fm-experts photos)
      root.querySelectorAll('[data-fm-sync]').forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
    }

    function go(index) {
      track.scrollTo({ left: index * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(maxIndex(), current() + 1)); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }, { passive: true });
    window.addEventListener('resize', update);
    // first measure from an IntersectionObserver callback (right after the browser's own layout), not at
    // DOMContentLoaded where reading scrollWidth forces an early layout (Lighthouse: forced reflow)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        update();
      }, { rootMargin: '100% 0px' });
      io.observe(root);
    } else {
      update();
    }
    bindMouseDrag(track, step, maxIndex, go);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fm-hscroll]').forEach(initHScroll);
    (scope || document).querySelectorAll('[data-fm-collection]').forEach(initFilters);
    (scope || document).querySelectorAll('[data-fm-carousel]').forEach(function (root) {
      if (root.fmCarousel) return;
      root.fmCarousel = new Carousel(root);
    });
    (scope || document).querySelectorAll('[data-fm-slider]').forEach(function (root) {
      if (root.fmSlider) return;
      root.fmSlider = new Slider(root);
    });
    (scope || document).querySelectorAll('[data-fm-totop]').forEach(function (btn) {
      if (btn.fmBound) return;
      btn.fmBound = true;
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-init sections after they are re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
